module.exports = __webpack_public_path__ + "img/EgyptTechCatapultS_ua.e4010185.webp";